import { render, staticRenderFns } from "./PopupAddIframe.vue?vue&type=template&id=4d84f2c2&"
import script from "./PopupAddIframe.vue?vue&type=script&lang=ts&"
export * from "./PopupAddIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports